import { render, staticRenderFns } from "./fieldRegexpRobot.vue?vue&type=template&id=ca2d4c3e&scoped=true"
import script from "./fieldRegexpRobot.vue?vue&type=script&lang=js"
export * from "./fieldRegexpRobot.vue?vue&type=script&lang=js"
import style0 from "./fieldRegexpRobot.vue?vue&type=style&index=0&id=ca2d4c3e&prod&lang=scss"
import style1 from "./fieldRegexpRobot.vue?vue&type=style&index=1&id=ca2d4c3e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ca2d4c3e",
  null
  
)

export default component.exports